"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_traffic-filters.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FiltersGroup = /*#__PURE__*/function (_Component) {
  _inherits(FiltersGroup, _Component);

  var _super = _createSuper(FiltersGroup);

  function FiltersGroup(props) {
    var _this;

    _classCallCheck(this, FiltersGroup);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", (0, _lodash.default)(function (_ref) {
      var value = _ref.value,
          selectedDefault = _ref.selectedDefault;
      return function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            selectedValues = _this$props.selectedValues;

        if (selectedDefault) {
          return onChange([]);
        }

        var selected = selectedValues.includes(value) ? selectedValues.filter(function (item) {
          return item !== value;
        }) : [].concat(_toConsumableArray(selectedValues), [value]);
        return onChange(selected);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState(function (_ref2) {
        var opened = _ref2.opened;
        return {
          opened: !opened
        };
      });
    });

    _this.state = {
      opened: !props.startClosed,
      startClosed: props.startClosed
    };
    return _this;
  }

  _createClass(FiltersGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$stats = _this$props2.stats;
      _this$props2$stats = _this$props2$stats === void 0 ? {} : _this$props2$stats;
      var stats = _this$props2$stats.global,
          name = _this$props2.name,
          filterFacets = _this$props2.filterFacets,
          selectedValues = _this$props2.selectedValues;
      var opened = this.state.opened;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "traffic-filters__group"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "traffic-filters__group__header"
        }, /*#__PURE__*/_react.default.createElement("h3", null, name), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: opened ? 'chevronup' : 'chevrondown',
          size: 15,
          onClick: this.toggleOpen,
          color: "black"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('traffic-filters__group__container', {
            'traffic-filters__group__container--opened': opened
          })
        }, filterFacets.map(function (_ref3) {
          var label = _ref3.label,
              value = _ref3.value,
              statKey = _ref3.statKey,
              disabled = _ref3.disabled,
              selectedDefault = _ref3.selectedDefault;
          return (/*#__PURE__*/_react.default.createElement(_uiKit.Checkbox, {
              key: value,
              onChange: _this2.handleFilterChange({
                value: value,
                selectedDefault: selectedDefault
              }),
              checked: selectedDefault ? !selectedValues.length : selectedValues.includes(value),
              disabled: disabled
            }, "".concat(label.toLowerCase(), " ").concat(stats && statKey ? "(".concat((0, _lodash2.default)(stats, statKey), ")") : ''))
          );
        })))
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.startClosed && !prevState.startClosed) {
        return {
          opened: false,
          startClosed: nextProps.startClosed
        };
      }

      if (!nextProps.startClosed && prevState.startClosed) {
        return {
          opened: true,
          startClosed: nextProps.startClosed
        };
      }

      return null;
    }
  }]);

  return FiltersGroup;
}(_react.Component);

exports.default = FiltersGroup;

_defineProperty(FiltersGroup, "defaultProps", {
  selectedValues: []
});